'use strict'

MarkerTooltip = require './marker_tooltip'
PlacePreviewDrawer = require '../../offers_map_preview_drawer/frontend/place_preview_drawer.coffee'

module.exports = class PlaceCard

  rootUrl: '/merchant-page/offers-map'
  config: null
  offersMap: null
  place: null
  map: null
  label: null
  $placePreview: null
  $el: null
  $marker: null
  $tooltip: null
  $mapContainer: null

  templates:
    placeCard: require '../place_card.html.mustache'
    mapMarker: require '../map_marker.html.mustache'
    tooltip: require '../tooltip.html.mustache'
    previewDrawer: require '../../offers_map_preview_drawer/main.html.mustache'

  constructor: ({ @offersMap, @place, @map, @label, @$placePreview, @config, @history }) ->
    @$mapContainer = @offersMap.$el.find '.map-container'

  placeTemplateData: ->
    data = {}
    data.translate = data.t = -> (str) -> I18n.t str

    _.extend data, @place,
      label: @label
      name: @place.name
      hasDeals: @hasDeals()
      hasDealsOrGdt: @hasDeals() or @hasGdt()
      formattedLocation: @getFormattedLocation()
      translations:
        recommendations: @getRecommendationsString()
        numberOfOffers: @getNumberOfOffersString()
        onlineOrdering: @getOnlineOrderingString()
        onlineOrderingDiscount: @getOnlineOrderingDiscountString()
        tooltipOnlineOrdering: @getTooltipOnlineOrderingString()

  render: ->
    @$el = $ @templates.placeCard.render(@placeTemplateData())
    @$el.click @cardClick
    @$el.hover @mouseEnter, @mouseLeave
    @$el

  isPlacePreviewShowingThisPlace: ->
    @place.uuid is @offersMap.placePreviewDrawer?.place?.uuid and @offersMap.placePreviewDrawer.isVisible()

  getFormattedLocation: ->
    return null unless @place.location.streetAddress?

    # Remove the period at the end of some addresses ("123 10th St.", for example)
    formattedLocation = @place.location.streetAddress.replace /\.$/, ''

    # Remove the street number
    formattedLocation = formattedLocation.replace(/^[0-9]+ /, '') if I18n.country is 'US'

    formattedLocation

  isOpenNow: ->
    @place.formattedHours?.openNow is true

  hasDeals: ->
    @place?.offers?.deal?.items?.length > 0

  hasGdt: ->
    return false unless @place.offers?.gdt?.data?.gdtFeatures?
    @place.offers.gdt.data.gdtFeatures.offersDelivery or @place.offers.gdt.data.gdtFeatures.offersTakeout

  getOnlineOrderingString: ->
    return unless @hasGdt()
    I18n.t 'js.modules.offers_map.place_card.online_ordering'

  getOnlineOrderingDiscountString: ->
    return unless @hasGdt()
    discount = @place.offers.gdt.data.discountBps
    return unless discount > 0
    I18n.t 'js.modules.offers_map.place_card.online_ordering_percentage_off', { percentage: discount / 100 }

  getTooltipOnlineOrderingString: ->
    return unless @hasGdt()
    discount = @place.offers.gdt.data.discountBps
    if discount > 0
      I18n.t 'js.modules.offers_map.tooltip.online_ordering_percentage_off', { percentage: discount / 100 }
    else
      I18n.t 'js.modules.offers_map.place_card.online_ordering'

  getNumberOfOffersString: ->
    return null unless @place.offers?
    count = (@place.offers.deal?.total ? 0) + (@place.offers.coupon?.total ? 0)
    return null unless count > 0
    I18n.t 'js.modules.offers_map.place_card.number_of_offers', { count }

  getRecommendationsString: ->
    return null unless @place.ugc?.recommendation?.showToUser is true
    {total, percentage} = @place.ugc.recommendation
    I18n.t 'js.modules.offers_map.place_card.recommendations', { total, percentage }

  addMarker: ->
    return unless @map?

    labelLength = @label?.toString()?.length

    data =
      uuid: @place.uuid
      label: @label
      labelLength:
        two: labelLength is 2
        three: labelLength is 3
        fourPlus: labelLength >= 4
      tooltipHtml: @templates.tooltip.render(@placeTemplateData())
      bhc:
        marker: "place-map-pin:#{@place.uuid}"
        dot: "place-map-dot:#{@place.uuid}"

    @$marker = $ @templates.mapMarker.render(data)
    @$marker.find('.marker-label').addClass 'default-cursor' if @config.showDrawer is true
    @$tooltip = @$marker.find '.marker-tooltip'

    $label = @$marker.find '.marker-label'
    $label.click @markerClick
    $label.hover @mouseEnter, @mouseLeave

    $dot = @$marker.find '.marker-dot'
    $dot.click @dotClick
    $dot.hover @mouseEnter, @mouseLeave

    @marker = new RichMarker
      position: new google.maps.LatLng @place.location.lonLat.lat, @place.location.lonLat.lon
      map: @map
      draggable: false
      shadow: false
      content: @$marker[0]

    @tooltip = new MarkerTooltip
      marker: @marker
      $hoverElement: @$el.add($label).add($dot)
      $mapContainer: @$mapContainer
      $tooltip: @$tooltip
      $marker: @$marker

  openPlacePage: ->
    window.location = "/biz/#{@place.slug}"

  cardClick: =>
    return @openPlacePage() if @config.showDrawer is false
    @offersMap.fullscreenHandler() unless @offersMap.isDesktopView() or @offersMap.$offersMap.hasClass('fullscreen')
    @offersMap.removeAllPlaceCardHighlights()
    @highlight()
    @showPreview()

  markerClick: =>
    return @openPlacePage() if @config.showDrawer is false

  dotClick: =>
    @offersMap.removeAllPlaceCardHighlights()
    @highlight()
    @scrollToCard()

  hidePreview: (saveInHistory = true) ->
    @removeHighlight()
    @offersMap.placePreviewDrawer?.hide { saveInHistory }
    @offersMap.placePreviewDrawer = null

  showPreviewFromHistory: ->
    @offersMap.removeAllPlaceCardHighlights()
    @highlight()
    @showPreview false

  showPreview: (saveInHistory = true) ->
    return @hidePreview(saveInHistory) if @isPlacePreviewShowingThisPlace()

    @offersMap.$offersMap.addClass 'show-preview-drawer'

    @offersMap.placePreviewDrawer = new PlacePreviewDrawer {
      offersMap: @offersMap
      $el: @$placePreview
      place: @place
    }

    @offersMap.placePreviewDrawer.onceOnClose (data) =>
      @removeHighlight()
      @offersMap.$offersMap.removeClass 'show-preview-drawer'
      @history.add { action: 'place-preview-hide-modal', placeId: @place.uuid } unless data?.saveInHistory is false

    @history.add({ action: 'place-preview-show-modal', placeId: @place.uuid }) unless saveInHistory is false

  highlight: ->
    @$el.addClass 'highlight'

  removeHighlight: ->
    @$el?.removeClass 'highlight'

  scrollToCard: ->
    if @offersMap.isUsingHorizontalScrolling()
      cardWidth = @$el.outerWidth()
      scrollLeft = cardWidth * @label - cardWidth
      @offersMap.$cardsOverflow.animate { scrollLeft }, 500
    else
      cardHeight = @$el.outerHeight()
      scrollTop = cardHeight * @label - cardHeight
      @offersMap.$cards.animate { scrollTop }, 500

  showImage: ->
    @$el.removeClass 'hide-image'

  showDot: ->
    @$marker.addClass 'show-dot'

  showPin: ->
    @$marker.removeClass 'show-dot'

  # This is used when hovering over either the Marker or the Card.
  mouseEnter: =>
    @$el.addClass 'active'
    @$marker.find('.marker-label').addClass('active') if @$marker?

  mouseLeave: =>
    @$el.removeClass 'active'
    @$marker.find('.marker-label').removeClass('active') if @$marker?

  destroy: ->
    @$marker?.remove()
    @$el?.remove()
    @marker?.setMap null
